import React, { useEffect } from "react";
import "./TermsCondition.css";
import { Container, Row } from "react-bootstrap";
import Banner from "../Service/Digital_Media_Services_Inner/Banner/Banner";

const TermsCondition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="privacy-policy TermsCondition">
        <Container>
          <Banner
            imgSrc={
              "/Assets/Images/Banners/Terms_And_Conditions/Terms_And_Conditions.png"
            }
          />
          <Row>
            <div className="heading-holder text-center mb-4">
              <h2>Terms & Conditions</h2>
            </div>
            <div className="text-holder mb-3">
              <p>
                Welcome to ReachOut Media Tech Pvt. Ltd. By accessing or using
                our website, you agree to comply with the following terms and
                conditions. Please read these terms carefully before using our
                services. If you do not agree with any part of these terms, you
                must not use our website or services.
              </p>
            </div>
            <div className="text-holder mb-3">
              <h3>1. General Terms</h3>
              <ol>
                <li>
                  <p>
                    ReachOut Media Tech Pvt. Ltd. provides advertising, digital
                    marketing, and related services as described on our website.
                  </p>
                </li>
                <li>
                  <p>
                    The content of this website is for your general information
                    and use only. It is subject to change without notice.
                  </p>
                </li>
                <li>
                  <p>
                    Unauthorized use of this website may give rise to a claim
                    for damages and/or be a criminal offense.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>2. Intellectual Property</h3>
              <ol>
                <li>
                  <p>
                    All content on this website, including but not limited to
                    text, graphics, logos, images, and software, is the property
                    of ReachOut Media Tech Pvt. Ltd. or its content suppliers
                    and is protected by applicable copyright and trademark laws.
                  </p>
                </li>
                <li>
                  <p>
                    You may not reproduce, distribute, or modify any content
                    from this website without prior written permission from
                    ReachOut Media Tech Pvt. Ltd.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>3. Use of Services</h3>
              <ol>
                <li>
                  <p>
                    You agree to provide accurate, current, and complete
                    information when engaging with our services.
                  </p>
                </li>
                <li>
                  <p>
                    Misuse of our services, including using them for illegal
                    activities, is strictly prohibited.
                  </p>
                </li>
                <li>
                  <p>
                    We reserve the right to terminate or suspend your access to
                    our services at our discretion, without prior notice, if you
                    violate these terms.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>4. Privacy Policy</h3>
              <ol>
                <li>
                  <p>
                    Your use of this website is also governed by our Privacy
                    Policy, which explains how we collect, use, and protect your
                    personal data. By using our website, you consent to the
                    practices described in the Privacy Policy.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>5. Limitation of Liability</h3>
              <ol>
                <li>
                  <p>
                    ReachOut Media Tech Pvt. Ltd. shall not be held liable for
                    any damages, including but not limited to direct, indirect,
                    incidental, or consequential damages arising from your use
                    of our website or services.
                  </p>
                </li>
                <li>
                  <p>
                    While we strive to provide accurate and up-to-date
                    information, we do not guarantee the completeness or
                    accuracy of the content on our website.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>6. Third-Party Links</h3>
              <ol>
                <li>
                  <p>
                    Our website may contain links to third-party websites for
                    your convenience. ReachOut Media Tech Pvt. Ltd. does not
                    endorse or take responsibility for the content of these
                    third-party websites.
                  </p>
                </li>
                <li>
                  <p>You access third-party websites at your own risk.</p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>7. Payment Terms</h3>
              <ol>
                <li>
                  <p>
                    All payments for services rendered by ReachOut Media Tech
                    Pvt. Ltd. must be made as per the agreed terms in the
                    invoice or contract.
                  </p>
                </li>
                <li>
                  <p>
                    Late payments may attract additional charges or penalties as
                    specified in the agreement.
                  </p>
                </li>
                <li>
                  <p>
                    ReachOut Media Tech Pvt. Ltd. reserves the right to suspend
                    or terminate services in case of non-payment.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>8. Modifications to Terms</h3>
              <ol>
                <li>
                  <p>
                    ReachOut Media Tech Pvt. Ltd. reserves the right to modify
                    these terms and conditions at any time. Changes will be
                    effective immediately upon posting on the website.
                  </p>
                </li>
                <li>
                  <p>
                    It is your responsibility to review these terms regularly to
                    stay informed about updates.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3">
              <h3>9. Governing Law</h3>
              <ol>
                <li>
                  <p>
                    These terms and conditions are governed by the laws of
                    India. Any disputes arising from these terms will be subject
                    to the exclusive jurisdiction of the courts of Maharashtra,
                    India.
                  </p>
                </li>
              </ol>
            </div>
            <div className="text-holder mb-3 address_holder">
              <h3>10. Contact Information</h3>
              <p>
                If you have any questions or concerns regarding these terms and
                conditions, please contact us at:
              </p>

              <p>ReachOut Media Tech Pvt. Ltd.</p>

              <div className="address_text_holder">
                <div className="row  justify-content-center">
                  <div className="col-md-6">
                    <p> Email: info@reachoutmediatech.com</p>
                  </div>
                  <div className="col-md-6">
                    <p> Toll-Free: 1800-268-2424 </p>
                  </div>
                  <div className="col-md-12">
                    <p>
                      Address: 6th Floor, Gandharv Empire, Raskar Chowk,
                      Magarpatta, Pune, Maharashtra, 411013
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TermsCondition;
